module.exports = __webpack_public_path__ + "static/media/plannr-logo.cd2213d0.svg";